// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html,\nbody {\n  overflow: hidden !important;\n  height: 100%;\n  width: 100%;\n}\n.aaa {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 54px;\n  height: calc(100% - 54px);\n  overflow-y: auto;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
